import { gql } from '@apollo/client'

export const CategoriesQuery = gql`
    query categoryQuery($id: String!) {
        firm(id: $id) {
            professionalDisciplines {
                id
                name
                categories(masterId: $id) {
                    name
                    id
                }
            }
        }
    }
`
